export default "../css/77fdecb3422fbe54ed88a7b3c8649786.ttf";